
import Api from './api'
import SessionStorage from '../helpers/sessionStorage'
import ENUM from '../assets/ENUM'

export default {
    get: function (email) {

        return Api.get(`/auth/mx/${ email }`)
            .then(result => {
                SessionStorage.setItem('email', email)
                if(result.isShutdown === true) {
                    SessionStorage.setItem(ENUM.STORAGE.IS_SHUTDOWN_EMAIL, email)
                } else {
                    SessionStorage.removeItem(ENUM.STORAGE.IS_SHUTDOWN_EMAIL)
                }
                return result
            })
    }
}
